import * as types from '../actions/actionTypes'

export default function MiscellaneousLiveReducer(state = [], action) {
    switch (action.type) {
        case types.live.GET_SETELIMINATION_SUCCESS:
            return { ...state, setElimination: action.data }
        case types.live.GET_SPRINTSL_SUCCESS:
            return { ...state, setSprintSL: action.data }
        case types.live.GET_SPRINTRESULT_SUCCESS:
            return { ...state, setSprintResult: action.data }
        case types.live.RESET_SPRINTSL:
            return { ...state, setSprintSL: null }
        case types.live.RESET_SPRINTRESULTS:
            return { ...state, setSprintResult: null }
        default:
            return state;
    }
}

